export default __webpack_public_path__ + "static/media/Top.1b360d86.png";